import { Navigate, useLocation } from 'react-router-dom'
import { isAuthed } from '@/lib/auth'

interface Props {
  children: React.ReactNode
}

/** 登录态守卫 — 未登录跳 /login，带回跳参数 */
export default function PrivateRoute({ children }: Props) {
  const location = useLocation()
  if (!isAuthed()) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />
  }
  return <>{children}</>
}
